import React from 'react'
import { ReactComponent as HubspotFavicon } from 'assets/svg/integrations/hubspot.svg'
import { ReactComponent as KavkomFavicon } from 'assets/svg/integrations/kavkom.svg'
import { ReactComponent as PipedriveFavicon } from 'assets/svg/integrations/pipedrive.svg'
import { ReactComponent as PowerlinkFavicon } from 'assets/svg/integrations/powerlink.svg'
import { ReactComponent as ZohoFavicon } from 'assets/svg/integrations/zoho.svg'
import { ReactComponent as SalesforceFavicon } from 'assets/svg/integrations/salesforce.svg'

export const ModeTypes = {
    Available: 'available',
    Unavailable: 'unavailable'
}

export const CallPageTypes = {
    Single: 'single',
    Multi: 'multi',
    Merged: 'merged'
}

export const ContactsPageTypes = {
    AllContacts: 'all',
    AddContact: 'add',
    TransferCall: 'transfer'
}

export const CallDirection = {
    Incoming: 'inbound',
    Outgoing: 'outbound',
    Local: 'local'
}

export const UserStatus = {
    Connecting: 'connecting',
    Disconnected: 'disconnected',
    Connected: 'connected',
    Available: 'available',
    Unavailable: 'unavailable',
    Registering: 'registering'
}

export const Events = {
    Login: 'login',
    Profile: 'profile',
    IncomingCall: 'incomingCall',
    OutgoingCall: 'outgoingCall',
    Logout: 'logout',
    UserStatus: 'userStatus'
}

export const BroadcastMessage = {
    FocusActiveTab: 'focusActiveTab',
    ActiveTabFocused: 'activeTabFocused',
    TabRegistered: 'tabRegistered',
    PrimeTabChanged: 'primeTabChanged'
}

// Properties that should be not allowed to share outside to parent window with postMessage by ParentNotifier
export const EventNotAllowedProps = {
    Global: ['access_token', 'token_type', 'extension_password']
}

export const TabIdCookieName = 'tabId'

export const RegistrationRequiredProps = ['extension_number', 'extension_password', 'domain_name', 'wss_url', 'port']

export const LogLevels = {
    debug: 'debug',
    test: 'test',
    production: 'production'
}

export const integrationFavicons = {
    hubspot: <HubspotFavicon width={18} height={20} />,
    kavkomcrm: <KavkomFavicon width={13} height={20} />,
    pipedrive: <PipedriveFavicon width={18} height={18} />,
    powerlink: <PowerlinkFavicon width={18} height={18} />,
    zoho: <ZohoFavicon width={16} height={18} />,
    salesforce: <SalesforceFavicon width={26} height={18} />
}
